// @ts-strict-ignore
import { component } from "picoapp";

export const accordion = component((node) => {
  const button = node.querySelector<HTMLElement>(".js-accordion-button");
  const contentWrapper = node.querySelector<HTMLElement>(
    ".js-accordion-content-wrapper"
  );
  const content = node.querySelector<HTMLElement>(".js-accordion-content");
  const contentMedia = node.querySelectorAll<
    HTMLImageElement | HTMLVideoElement
  >("img, video");

  const handleAccordionToggle = (e: MouseEvent) => {
    e.preventDefault();

    if (node.dataset.isOpen === "true") {
      handleCloseAccordion();
    } else {
      handleOpenAccordion();
    }
  };

  const handleOpenAccordion = () => {
    button.querySelector(".accordion-plus").classList.add("hidden");
    button.querySelector(".accordion-minus").classList.remove("hidden");
    contentWrapper.classList.remove("invisible");
    contentWrapper.classList.add("visible", "opacity-100");
    contentWrapper.style.height = `${content.offsetHeight}px`;
    node.dataset.isOpen = "true";
    button.dataset.mtrTarget = "open accordion";
  };

  const handleCloseAccordion = () => {
    button.querySelector(".accordion-plus").classList.remove("hidden");
    button.querySelector(".accordion-minus").classList.add("hidden");
    contentWrapper.classList.add("invisible");
    contentWrapper.classList.remove("visible", "opacity-100");
    contentWrapper.style.height = "0";
    node.dataset.isOpen = "false";
    button.dataset.mtrTarget = "close accordion";
  };

  if (node.dataset.isOpen === "true") {
    contentWrapper.style.height = `${content.offsetHeight}px`;
  }

  button.addEventListener("click", handleAccordionToggle);
  button.addEventListener("tbsp:close-accordion", handleCloseAccordion);

  const ro = new ResizeObserver((entries) => {
    entries.forEach(() => {
      if (node.dataset.isOpen === "true") {
        contentWrapper.style.height = `${content.offsetHeight}px`;
      }
    });
  });

  // Observe one or multiple elements
  ro.observe(node);

  // Resize the accordion content wrapper when images or videos are loaded
  contentMedia.forEach((media) => ro.observe(media));

  return () => {
    button.removeEventListener("click", handleAccordionToggle);
    ro.disconnect();
  };
});
